import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import DOM from '../../utils/DOM';

export default class WindowFocus extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  };

  state = {
    focused: true,
  }

  componentDidMount() {
    DOM.setOnFocusHandler(() => {
      this.setState({
        focused: true,
      });
    })
    DOM.setOnBlurHandler(() => {
      this.setState({
        focused: false,
      });
    });
    this.setState({
      focused: DOM.hasFocus(),
    });
  };

  render() {
    return (
      <div className="WindowFocus">
      <WindowFocusContext.Provider value={this.state.focused}>
      {this.props.children}
      </WindowFocusContext.Provider>
      </div>);
  }
}

export const WindowFocusContext = React.createContext();
